import config from 'config'

export const casaApiUrl = config.casaApiUrl;



// WEBPACK FOOTER //
// ./src/configs/casa-api.js